import { Action, createReducer, on } from '@ngrx/store';
import { ForgotPasswordActions } from '../actions';

export const forgotPasswordFeatureKey = 'forgotPassword';

export interface State {
  errorMessage: any;
  forgotPasswordLoading: boolean;
  forgotPasswordSuccess: boolean;
}

export const initialState: State = {
  errorMessage: null,
  forgotPasswordLoading: false,
  forgotPasswordSuccess: false,
};

const forgotPasswordReducer = createReducer(
  initialState,
  on(ForgotPasswordActions.forgotPassword, (state) => ({
    ...state,
    forgotPasswordLoading: true,
    errorMessage: null,
  })),
  on(ForgotPasswordActions.forgotPasswordSuccess, (state, { }) => ({
    ...state,
    forgotPasswordLoading: false,
    forgotPasswordSuccess: true,
    errorMessage: null,
  })),
  on(ForgotPasswordActions.forgotPasswordFailure, (state, { error }) => ({
    ...state,
    errorMessage: error,
    forgotPasswordLoading: false,
    forgotPasswordSuccess: false
  })),
  on(ForgotPasswordActions.resetForgot, (state) => ({
    ...state,
    errorMessage: null,
    forgotPasswordLoading: initialState.forgotPasswordLoading,
    forgotPasswordSuccess: initialState.forgotPasswordSuccess
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return forgotPasswordReducer(state, action);
}
